export function buildCommunitySearchHref(
  pathname: string,
  currentSearch: string,
  updates: Record<string, string | null | undefined>,
): string {
  const params = new URLSearchParams(currentSearch);

  // `quick` is the legacy sort key. All new links use the canonical `sort` key.
  params.delete("quick");

  for (const [key, value] of Object.entries(updates)) {
    if (value === null || value === undefined || value === "") {
      params.delete(key);
    } else {
      params.set(key, value);
    }
  }

  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}
